import LovData from './LovData';

class LovControl {
  constructor(items) {
    this.items = items;
    this.list = this.list.bind(this);
    this.get = this.get.bind(this);
    this.getItem = this.getItem.bind(this);
  }

  list() {
    return this.items;
  }

  get(key) {
    const item = this.getItem(key);

    return (item) ? item.text : '';
  }

  getItem(key) {
    if (this.items && this.items.length > 0) {
      var item = this.items.find((a) => a.key === key);
      return item || null;
    }

    return null;
  }

}

function LovParse() {
  let lovDataObj = {};

  for (var key in LovData) {
    lovDataObj[key] = new LovControl(LovData[key]);
  }

  return lovDataObj;
}

export default LovParse();